<script setup lang="ts">
import { useRoute } from 'vue-router'

import storageService from '@/services/storage'

const route = useRoute()
</script>

<template>
  <div class="bg-light" style="min-height: 100vh">
    <div v-if="route.name !== 'login'" class="text-end">
      <button class="btn btn-link" @click="storageService.signOut()">Logout</button>
    </div>
    <div class="py-3">
      <router-view />
    </div>
  </div>
</template>

<style></style>
